import popupAlert from '@images/popup-alert.png';

import AccountFooter from '@components/account-footer/AccountFooter';
import { Modal } from '@components/index';
import { useAppDispatch } from '@core/store';
import { setBlacklistedModal } from '@layouts/main-header/userSlice';
import { Org } from 'types/organization';

const BLACKLIST_SUPPORT_EMAIL = 'support@cofee.app';

interface BlacklistedModalProps {
  isOpen: boolean;
  orgList?: Org[];
  onSwitchAccount?: () => void;
}

const BlacklistedModal = ({
  isOpen,
  orgList = [],
  onSwitchAccount
}: BlacklistedModalProps) => {
  const dispatch = useAppDispatch();

  return (
    <Modal isOpen={isOpen} isClickOutsideRequired={false} className="w-120">
      <div className="flex flex-col items-center px-8 pb-6 pt-8">
        <img
          src={popupAlert}
          alt="alert"
          className="mb-4 h-28 w-full object-contain"
        />
        <h2 className="mb-3 text-center text-2xl font-semibold text-cofeeNeutral10">
          Your account has been blacklisted!
        </h2>
        <p className="text-center text-base text-cofeeNeutral8">
          If you believe this is a mistake, contact{' '}
          <a
            href={`mailto:${BLACKLIST_SUPPORT_EMAIL}`}
            className="font-medium text-cofeePrimary6 underline"
          >
            {BLACKLIST_SUPPORT_EMAIL}
          </a>{' '}
          and we&apos;ll review it.
        </p>
      </div>
      <AccountFooter
        orgList={orgList}
        onSwitchAccount={onSwitchAccount}
        // Clear the blacklisted modal so the account-creation flow can call its APIs.
        onBeforeCreateAccount={() => dispatch(setBlacklistedModal(null))}
      />
    </Modal>
  );
};

export default BlacklistedModal;
